var ScheduleSuggestionsModule = /** @class */ (function () {
    function ScheduleSuggestionsModule() {
    }
    return ScheduleSuggestionsModule;
}());
export { ScheduleSuggestionsModule };
